import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putOwner } from '../Api'

export default generateApiAction({
  baseType: Types.OWNERS.PUT,
  api: putOwner,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/owners/PutAction.js